import styles from './ExtraCheckInModal.module.scss';
import { values } from '../CheckIn/checkInValues';
import { MiddleSchoolCheckInEntry } from '../../peekapak-types/ReportDataExchangeTypes';

interface Props {
  hideModal: () => void;
  checkIns: MiddleSchoolCheckInEntry[];
  title: string;
}

const ExtraCheckInModal = ({ hideModal, checkIns, title }: Props): JSX.Element => {
  const getTextColor = (feeling: string) => {
    if (feeling === undefined) return '#86939e';
    if (values.findIndex((value) => value.subEmotions.includes(feeling)) < 2) return '#43484d';
    return '#fff';
  };
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <h2 className={styles.name}>
          {title} -&nbsp;
          {new Date(checkIns[0].createdAt).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
          })}
        </h2>
        <button onClick={hideModal}>x</button>
      </div>
      <div className={styles.studentDataContainer}>
        {checkIns.map((checkIn, index) => {
          const emotionColor =
            values.find((value) => value.subEmotions.includes(checkIn.feeling))?.segmentColor || '#bbc2ca';
          const time = new Date(checkIn.createdAt).toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
          });
          return (
            <div className={styles.emotion} key={`${checkIn.feeling} ${index} activity.id`}>
              <div
                className={styles.dataCell}
                style={{
                  backgroundColor: emotionColor,
                }}
              >
                <h4
                  style={{
                    color: getTextColor(checkIn.feeling),
                  }}
                >
                  {checkIn.feeling.replace('/', ' / ') || '-'}
                </h4>
              </div>
              <p className={styles.timeText}>{time}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ExtraCheckInModal;
